import { Copy, Plus, Search } from "lucide-react";
import { useState } from "react";

import { RadioPanels } from "../../shared/radio-panels";
import { Button } from "../../ui/button";
import { DialogDescription, DialogHeader, DialogTitle } from "../../ui/dialog";
import type { ModalType } from "./common";

interface ModalTypeFormProps {
  onSubmit: (itemType: ModalType) => void;
}

export function ModalTypeForm({ onSubmit }: ModalTypeFormProps) {
  const [modalType, setModalType] = useState<ModalType>("new");

  return (
    <form
      className="space-y-5"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(modalType);
      }}
    >
      <DialogHeader className="items-center space-y-0">
        <DialogTitle>Add modifiers</DialogTitle>
        <DialogDescription>How do you want to add modifiers?</DialogDescription>
      </DialogHeader>
      <RadioPanels
        items={[
          {
            icon: Plus,
            value: "new",
            label: "New modifiers",
            description: "Create new modifiers from scratch",
          },
          {
            icon: Copy,
            value: "duplicate",
            label: "Duplicate similar modifiers",
            description:
              "Choose an existing modifier group to use as a template",
          },
          {
            icon: Search,
            value: "existing",
            label: "Apply existing modifiers",
            description: "Share and sync modifier groups",
          },
        ]}
        onValueChange={setModalType}
        orientation="vertical"
        value={modalType}
      />
      <Button className="w-full" size="lg" type="submit">
        Next
      </Button>
    </form>
  );
}
